// @flow

import { authenticatedFetch } from '../../../api/request';

export default function getFeaturesForUserId(userId: number) {
    return authenticatedFetch(`/v5/users/${userId}/features`);
}



// WEBPACK FOOTER //
// ./src/v5/features/api/getFeaturesForUser.js